import { API } from '@/api';
import { fetcher } from '@/services/fetcher';
import { toURLSearchParams } from '@/utils/url';

import { type LocationsParams, locationPagedResultSchema } from '../../../models';

const pricing = fetcher.extend(() => ({ prefixUrl: `${API.BASE_PRICING}` }));

export const fetchLocations = (params: LocationsParams, { signal }: { signal?: AbortController['signal'] } = {}) => {
  const { city, countryCode, limit = 10, locationCode, offset = 0, portKey, sorting, stateCode } = params;

  return pricing
    .get('locations/search', {
      searchParams: toURLSearchParams({
        City: city || undefined,
        CountryCode: countryCode,
        LocationCode: locationCode || undefined,
        PortKey: portKey,
        Skip: offset,
        Sorting: sorting || undefined,
        StateCode: stateCode || undefined,
        Take: limit,
      }),
      signal,
    })
    .json(locationPagedResultSchema);
};
